import React, { useEffect, useContext } from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import '../styles/css/AboutMe.css';
// Add import for image
import whoamiImage from '../styles/images/whoami1.webp';
// Add import for framer-motion
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { LanguageContext } from '../App';

const AboutMe = () => {
  // Add animation controls
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  // Trigger animations when section comes into view
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100
      }
    }
  };

  const imageVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 100
      }
    }
  };

  const { language, translations } = useContext(LanguageContext);

  return (
    <Container className="about-container">
      <motion.div
        initial="hidden"
        animate={controls}
        variants={containerVariants}
        ref={ref}
      >
        <motion.div variants={itemVariants}>
          <Typography variant="h2" component="h2" className="section-title">
            {translations[language].aboutTitle}
          </Typography>
        </motion.div>
        
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={4}>
            <motion.div variants={imageVariants} className="about-image-container">
              <a href="https://www.instagram.com/p/C8gdNOzI8ZX/" target="_blank" rel="noreferrer">
                <img
                  src={whoamiImage}
                  alt="Photographer"
                  className="about-image"
                  style={{ 
                    width: '300px', 
                    height: '500px', 
                    objectFit: 'cover',
                    borderRadius: '10px' 
                  }}
                />
              </a>
              
            </motion.div>
            <Typography 
                variant="body2" 
                component="p" 
                style={{ 
                  textAlign: 'center', 
                  marginTop: '8px',
                  fontSize: '0.875rem'
                }}
              >
                כן, אני בדרך כלל עם מצלמה ביד 😄
              </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Box className="about-content">
              <motion.div variants={itemVariants}>
                <Typography variant="h4" component="h3" gutterBottom>
                  {translations[language].aboutGreeting}
                </Typography>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                  {translations[language].aboutSubtitle}
                </Typography>
              </motion.div>
              
              {/* Wrap each paragraph in motion.div */}
              <motion.div variants={itemVariants}>
                <Typography variant="body1" paragraph>
                  {translations[language].aboutParagraph1}
                </Typography>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <Typography variant="body1" paragraph>
                  {translations[language].aboutParagraph2}
                </Typography>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <Typography variant="body1" paragraph>
                  {translations[language].aboutParagraph3}
                </Typography>
              </motion.div>
              
              <motion.div variants={itemVariants}>
                <Typography variant="body1" paragraph>
                  {translations[language].aboutParagraph4}
                </Typography>
              </motion.div>

              { translations[language].aboutParagraph5 && (
              <motion.div variants={itemVariants}>
                <Typography variant="body1" paragraph>
                  {translations[language].aboutParagraph5}
                </Typography>
              </motion.div>
              )}
              <Box mt={2}>
                <Typography variant="h6" gutterBottom>                
                </Typography>
                <Typography variant="body1">                
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </motion.div>
    </Container>
  );
}

export default AboutMe;
